import { axios, Response } from '../index'

const deleteGroupFile = (groupFileId: string): Response<null> => {
  return axios.delete(`/v1/group-files/${groupFileId}`)
}

export default deleteGroupFile
